import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from './components/Layout';
import { LoginPage, VerifyPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { ServersPage } from './pages/Servers';
import { ServerDetailPage } from './pages/ServerDetail';
import { TenantsPage } from './pages/Tenants';
import { TenantDetailPage } from './pages/TenantDetail';
import { CleanupPage } from './pages/Cleanup';
import { TiersPage } from './pages/Tiers';
import { ToolsPage } from './pages/Tools';
import { SshKeysPage } from './pages/SshKeys';
import { ActivityPage } from './pages/Activity';
import { SettingsPage } from './pages/Settings';
import { SkillsPage } from './pages/Skills';
import { OperatorsPage } from './pages/Operators';
import { AccountPage } from './pages/Account';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/servers" element={<ServersPage />} />
            <Route path="/servers/:id" element={<ServerDetailPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/tenants/:id" element={<TenantDetailPage />} />
            <Route path="/cleanup" element={<CleanupPage />} />
            <Route path="/tiers" element={<TiersPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/skills" element={<SkillsPage />} />
            <Route path="/operators" element={<OperatorsPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/ssh-keys" element={<SshKeysPage />} />
            <Route path="/activity" element={<ActivityPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
